import { Resizable } from 'react-resizable';
import type { SyntheticEvent } from 'react';

interface ResizableTitleProps extends React.HTMLAttributes<HTMLTableCellElement> {
  width?: number;
  onResize?: (e: SyntheticEvent, data: { size: { width: number; height: number } }) => void;
}

/**
 * antd Table 表头单元格增强：为带 width 的列渲染右边缘可拖拽手柄，
 * 拖拽时通过 onResize 回调把新宽度交回调用方（见 useResizableColumns）。
 */
export function ResizableTitle({ width, onResize, ...restProps }: ResizableTitleProps) {
  if (!width) {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="resizable-col-handle"
          onClick={(e) => e.stopPropagation()}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
}
